import React, { useEffect } from 'react';
import FyraApiSection from '../components/FyraApiSection';
import Header from '../components/Header';
import Footer from '../components/Footer';

const FyraApiPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <FyraApiSection />
      <Footer />
    </>
  );
};

export default FyraApiPage;
